import React from 'react';

export default function SelectedShipToAddressLabel(props) {
    const { address } = props;
    return (
        <>
            <div>{address?.accountName ? address.accountName : ' '}</div>
            <div>{address?.addressLine1}</div>
            <div>
                {' ' +
                    address?.city +
                    ', ' +
                    (address?.region ? address.region + ', ' : '') +
                    address?.postalCode}
            </div>
        </>
    );
}
